<template>
    <main id="liste" v-cloak>
        <HeaderTab 
            :title="$t('menu.actes.actes')" 
            :swiper_tabs="swiper_tabs" 
            :swiper_action="changeTab" 
        />

        <div id="content">
            <shutter-panel ref="shutterPanel" />
        </div>
    </main>
</template>


<script type="text/javascript">
    import ActeMixin from "@/mixins/Actes.js"
    import Shutter from "@/mixins/Shutter.js"
    import ShutterActs from '@/mixins/shutters-manager/Acts.js'

	export default {
		name: "acteListe",
		mixins: [ActeMixin, Shutter, ShutterActs],
		data () {
			return {
				swiper_tabs: [{
                        label: 'acte.tous',
                        href : 'acteListe',
                        active: true,
                        name: ''
                    }
                ],
				actual_tab: {},
                actes_groupes: [],
                actes: []
			}
		},
		created() {
            // On init les données de la vue
            this.init_component()
		},
		methods: {
            async init_component() {
                // Charger les actes d'abord pour connaître les groupes présents
                const start_date = new Date(new Date().setMonth(new Date().getMonth() - 3))
                const end_date = new Date()
                this.actes = await this.getActes(start_date.toDateInputValue(), end_date.toDateInputValue()) || []
                
                // Extraire les codes de groupes présents dans les actes
                const groupesPresents = [...new Set(
                    this.actes
                        .filter(a => a.actetype && a.actetype.actestype_codegroupe)
                        .map(a => a.actetype.actestype_codegroupe)
                )]

                this.actes_groupes = await this.getActesGroupes(false)

                // Ne garder que les groupes qui ont des actes
                this.actes_groupes
                    .filter(acte_groupe => groupesPresents.includes(acte_groupe.actesgroupe_code))
                    .forEach(acte_groupe => {
                        this.swiper_tabs.push({
                            label: 'acte.'+acte_groupe.actesgroupe_label.toLowerCase(),
                            active: false,
                            name: acte_groupe.actesgroupe_code
                        })
                    })

                this.actual_tab = this.swiper_tabs[0]
                this.setupActHistory(this.actual_tab.name)
			},

			async changeTab(tab) {
                this.actual_tab.active = false
				this.actual_tab = tab
                tab.active = true
                this.shutterPanel().update('act-history', 'actualTab', this.actual_tab.name)
			}
		},
		components: {
            HeaderTab: () => import('@/components/HeaderTab')
		}
	}
</script>